<div class="tabbable__body rounded-top-right no-margin">
  <h3>Här kan du administrera universum</h3>

  @if (!showUploadForm()) {
    <div class="button-filter-container">
      <button
        class="button primary-1"
        (click)="showUploadForm.set(true)"
      >
        Ladda upp nya universumsiffror
      </button>
    </div>
  } @else {
      <label for="file" class="button secondary" role=button>
        {{ uploadFileLabel() }}
      </label>
      <input
        type="file"
        id="file"
        class="hidden"
        [accept]="acceptedFileTypes"
        (change)="setFile($event.target.files[0])"
      />

      <button
        class="button primary-1"
        (click)="sendFile()"
        [disabled]="uploadDisabled"
      >
        Ladda upp
      </button>
      <button class="button secondary" (click)="cancel()">Avbryt</button>
  }
  <div class="sticky-header">
    <h3>Aktiva universumsiffror för målgrupper</h3>
  </div>

  <app-woo-table [data]="targetUniverseTableData()" [loaderTpl]="loader">
    <woo-table-column header="Åldersspann" name="age_span"></woo-table-column>
    <woo-table-column header="Kvinnor" name="woman_universe">
      <ng-template let-cell>{{ cell.value | number:'1.0-0' }}</ng-template>
    </woo-table-column>
    <woo-table-column header="Män" name="man_universe">
      <ng-template let-cell>{{ cell.value | number:'1.0-0' }}</ng-template>
    </woo-table-column>
    <woo-table-column header="Alla" name="all_universe">
      <ng-template let-cell>{{ cell.value | number:'1.0-0' }}</ng-template>
    </woo-table-column>
  </app-woo-table>


  <div class="sticky-header">
    <h3>Aktiva universumsiffror för regioner</h3>
  </div>

  <app-woo-table [data]="regionUniverseTableData()" [loaderTpl]="loader">
    <woo-table-column header="Region" name="region"></woo-table-column>
    <woo-table-column header="Befolkning" name="region_universe">
      <ng-template let-cell>{{ cell.value | number:'1.0-0' }}</ng-template>
    </woo-table-column>
  </app-woo-table>

  <ng-template #loader let-data>
    <div class="text-center w-100">
      @if(loading()) {
        <dot-loader [large]="true"></dot-loader>
      } @else {
        <span>Ingen data tillgänglig</span>
      }
    </div>
  </ng-template>
</div>  
